import React, { useState } from "react";
import { Image, Card, Button, Row, Col } from "react-bootstrap";
import { Container } from "react-bootstrap";

import styled from "styled-components";
import { handleOnImg404 } from "../../utils";

const CustomVerticalCard = styled(Card)`
  width: 27rem;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  border:0
`;

const CustomImgCard = styled(Card.Img)`
  object-fit: contain;
  height: 100%;
`;

const CustomCardTitle = styled(Card.Title)`
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 1.563rem;
`;

const CustomCardText = styled(Card.Text)`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 1.563rem;
  margin-bottom: 0.25rem;
`;

const CustomCardTextCenter = styled(Card.Text)`
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 1.563rem;
  margin-bottom: 0.25rem;
`;

const ImageWrapper = styled.div`
  height: 9.9rem;
`;

// Componente genérico para cartas que tienen la imagen situada a la izquierda y el texto a la derecha
//  Recibe:
// title --> El título de la carta
// cardImage --> La img de la carta, src o fichero
// body --> un array de objetos para mostrar el texto de la carta, cada item del array será un objeto con un value y una imagen opcional a colocar
//

const VerticalCard = ({ title, cardImage, body = [], imgOnError, buttons = [], ciudad = '', pais = '', ...props }) => {
  return (
    <CustomVerticalCard {...props}>
      {cardImage &&
        <ImageWrapper>
          <CustomImgCard variant={"top"} className={"p-2"} src={cardImage} onError={(e) => handleOnImg404(e, imgOnError)} />
        </ImageWrapper>
      }
      <Card.Body>
        <CustomCardTitle title={title}>{title}</CustomCardTitle>
        <CustomCardTextCenter title={`${ciudad}, ${pais}`}>{`${ciudad} ${ciudad ? pais ? ', ' : '' : ''} ${pais}`}

        </CustomCardTextCenter>

        {body.map((textItem, index) => {
          let img = textItem.img ? <Image className={"align-top p-2 mr-1"} src={textItem.img.url} height={textItem.img.size} /> : "";
          return (
            textItem.value && (
              <CustomCardText key={index} title={textItem.value} className={textItem.className && textItem.className}>
                {img}
                {textItem.value}
              </CustomCardText>
            )
          );
        })}
        <Container className={"text-center"}>
          {buttons && buttons.map((button, index) => {
            return button;
          })}
        </Container>

      </Card.Body>
    </CustomVerticalCard>
  );
};

export default VerticalCard;
